import { AspectRatio, Box, Flex, Heading, Image, Skeleton, Text } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { conferenceHubCountersQueryOptions } from '@/queries/upgrade/conferenceHubCounters';
import { ThinConference } from '@/resources/ThinConference';

interface IPublisherCardProps {
  publisher: ThinConference;
  hubId: string;
}
export const PublisherCard: FC<IPublisherCardProps> = ({ publisher, hubId, ...rest }) => {
  const { t } = useTranslation();

  const { data: counters } = useQuery(conferenceHubCountersQueryOptions([publisher.id], hubId));
  const thisCounter = counters?.[0];

  const visibleCount = thisCounter?.visible_library_events_count ?? publisher.visibleLibraryEventsCount;
  const lectureCount = thisCounter?.lectures_count ?? publisher.lecturesCount;

  return (
    <Flex
      borderColor="gray.200"
      h="full"
      borderWidth="1px"
      bg="white"
      flexDir="column"
      justifyContent="space-between"
      {...rest}
    >
      <AspectRatio maxW="full" ratio={3 / 2}>
        {/* gray.50 (#F3F5F5) rather than the page white, so transparent artwork reads as a tile */}
        <Image
          src={publisher.mediumHeaderImageUrl}
          alt={publisher.name}
          bg="gray.50"
          fallback={<Skeleton size="full" />}
        />
      </AspectRatio>
      <Flex flexDir="column" justifyContent="space-between" px="8" py="4" h="full">
        <Box>
          <Heading fontSize="md">{publisher.abbreviation}</Heading>
          <Heading noOfLines={3} mt={2} fontSize="2xl">
            {publisher.name}
          </Heading>
        </Box>
        <Flex alignItems="center" mt={4}>
          <Text>
            <Heading fontSize="xl" as="span" mr="1">
              {visibleCount}
            </Heading>
            {t('common.event_plural')}
          </Text>
          <Text ml="8">
            <Heading fontSize="xl" as="span" mr="1">
              {lectureCount}
            </Heading>
            {t('common.lecture', { count: lectureCount })}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
